import { Landing } from "@/components/Landing/Welcome";

type Props = {};

export function LandingPage({}: Props) {
  return <Landing />;
}
